module.exports = __webpack_public_path__ + "img/standing.dfe5c9d9.svg";